var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.enabled)?_c('div',{ref:"root",staticClass:"cursor",class:{ 'is-hidden': _vm.state.hidden || !_vm.visible },attrs:{"aria-hidden":"true"}},[_c('div',{ref:"ball",staticClass:"cursor__ball"},[_c('span',{staticClass:"cursor__label"},[_vm._v(_vm._s(_vm.state.label))])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }